/**
 * Column resizer for data table
 * @param callback - callback method that will be called aster succesfull resize
 * @param id - id of the data table element
 */
var ColumnResizer = function (id, callback) {
    if (callback === void 0) { callback = null; }
    var MIN_WIDTH = 105;
    var resizeSelector = "#" + id + " .resizer";
    var resizers = document.querySelectorAll(resizeSelector);
    var initialX;
    var initialWidth;
    var gridCell;
    /**
     * Gets the columns fro given column id
     * @param columnId - data column id
     */
    var getColumnCells = function (columnId) {
        var columnCells = document.querySelectorAll("#" + id + " [data-column=\"" + columnId + "\"]");
        return columnCells;
    };
    /**
     * Initiates the drag event by attaching event handlers on mouse down
     * @param e - mouse event
     */
    var initiateDrag = function (e) {
        initialX = e.clientX;
        var parent = e.target.parentElement;
        gridCell = parent;
        initialWidth = parseInt(parent.style.minWidth, 10);
        document.addEventListener('mousemove', startDrag);
        document.addEventListener('mouseup', stopDrag);
    };
    /**
     * starts resizing on mouse move
     * @param e - mouse event
     */
    var startDrag = function (e) {
        var distance = e.clientX - initialX;
        var dataColumn = gridCell.getAttribute('data-column');
        var newWidth = initialWidth + distance;
        var minWidth = parseInt(gridCell.getAttribute('data-min-width') || MIN_WIDTH.toString(), 10);
        getColumnCells(dataColumn).forEach(function (element) {
            var cell = element;
            newWidth = newWidth < minWidth ? minWidth : newWidth;
            cell.style.minWidth = newWidth + 'px';
            cell.style.maxWidth = newWidth + 'px';
        });
    };
    /**
     * Removes the drag event handlers
     * @param e - mouse event
     */
    var stopDrag = function (e) {
        document.removeEventListener('mousemove', startDrag);
        document.removeEventListener('mouseup', stopDrag);
        // calls callback in case of any
        if (callback) {
            callback();
        }
    };
    if (!!resizers.length) {
        resizers.forEach(function (resizer) {
            resizer.addEventListener('mousedown', initiateDrag);
        });
    }
};
export default ColumnResizer;
